import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    name,
    orgId,
    depId,
    budgetUnit = '',
    budgetTotal = 0,
    annualTarget = '',
    assetType = 0,
    kpiType = 0,
    establish = (new Date()).getFullYear(),
    planYear = (new Date()).getFullYear(),
    contactPer = '',
    contactTel = '',
    inputName = '',
    inputDate = '',
    order = 0,
    layers = 3,
    budgetType = 0,
    needAssessment = 0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.save, {
        id,
        name,
        orgId,
        depId,
        budgetUnit,
        budgetTotal,
        annualTarget,
        assetType,
        kpiType,
        establish,
        planYear,
        contactPer,
        contactTel,
        inputName,
        inputDate,
        order,
        layers,
        budgetType,
        needAssessment,
    }, options);
    if (error) return { error, status };
    return content || {};
};

